export const distinctBy = (array, prop) => {
    const newArr = []
    array.forEach(x => {
        const exists = newArr.filter(y => y[prop] === x[prop])[0]
        if (!exists){
            newArr.push(x)
        }
    });
    return newArr
}